import { render, staticRenderFns } from "./registInfo.vue?vue&type=template&id=4f139678&scoped=true"
import script from "./registInfo.vue?vue&type=script&lang=js"
export * from "./registInfo.vue?vue&type=script&lang=js"
import style0 from "./registInfo.vue?vue&type=style&index=0&id=4f139678&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f139678",
  null
  
)

export default component.exports